/*
 * @Author: your name
 * @Date: 2020-11-19 16:45:08
 * @LastEditTime: 2021-04-06 15:39:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /v-intersection/src/plugins/getTem.js
 */
const requireEffect = require.context("../components/code", false, /\.vue$/);

console.log(requireEffect);

const effectList = requireEffect.keys();

// console.log("effectList: ", effectList);

const effects = {};
// const components = {};

for (const filename of effectList) {
  const name = filename.replace("./", "").replace(".vue", "");
  // console.log("name: ", name);

  const raw = require(`!!raw-loader!../components/code/${name}`).default;

 
  const temjs = /<template>(.*)<\/script>/g
    .exec(JSON.stringify(raw))[0]
    .replace(/^\\n/, "") // remove leading linebreak
    .replace(/\\n/g, "\n") // replace escape characters
    .replace(/\\"/g, '"');





    

  const html = /<template>(.*?)<\/template>/g // find html between template tags
    .exec(JSON.stringify(raw))[0]
    .replace(/<\/?template>/g, "") // remove template tags
    .replace(/^\\n/, "") // remove leading linebreak
    .replace(/\\n/g, "\n") // replace escape characters
    .replace(/\\"/g, '"');

  // const css = /<style(.*?)<\/style>/g // find css between style tags
  //   .exec(JSON.stringify(raw))[0]
  //   .replace(/<\/?style(?: scoped)?>/g, '') // remove style tags
  //   .replace(/^\\n/, '') // remove leading linebreak
  //   .replace(/\\n/g, '\n'); // replace \n with newlines
    
    
  const all = /<template(.*?)<\/style>/g // find css between style tags
    .exec(JSON.stringify(raw))[0]
    // .replace(/^\\n/, '') // remove leading linebreak
    .replace(/\\n/g, '\n') // replace \n with newlines
    .replace(/\\"/g, '"');


    

    console.log("🚀 ~ file: getTem.js ~ line 54 ~ all", all)


  effects[name] = { raw, temjs, html ,all};
  // console.log(effects);
  //   components[name] = component;
}

// export { effects, components };
export { effects };
